/**
 * Organization Operation Grouping Rules
 * Handles grouping for selection, expansion, filtering, sorting, and search operations
 */

import { Operation, UIOperation } from '@/shared/types/projectData';
import { GroupingRule } from './transformRules';

export const organizeRules: Record<string, GroupingRule> = {
  // Selection operations
  'select-node': {
    opensGroup: 'organize',
    name: (op: Operation) => {
      const uiOp = op as UIOperation;
      const after = uiOp.details?.after as Record<string, unknown> | undefined;
      const selected = (after?.selected as string[]) || [];
      return selected.length > 1 ? 'Multi-select items' : 'Select item';
    },
    mergeWindow: 1000,
    mergeCondition: () => true // Always merge selection operations
  },

  // Expansion operations
  'toggle-expand': {
    opensGroup: 'organize',
    name: (op: Operation) => {
      const uiOp = op as UIOperation;
      const after = uiOp.details?.after as Record<string, unknown> | undefined;
      const expanded = after?.expanded;
      return expanded ? 'Expand items' : 'Collapse items';
    },
    mergeWindow: 1500
  },

  // Filtering operations
  'filter-change': {
    opensGroup: 'organize',
    name: () => 'Update filters',
    mergeWindow: 2000,
    mergeCondition: () => true // Always merge filter changes
  },

  // Sorting operations
  'sort-change': {
    opensGroup: 'organize',
    name: () => 'Change sort',
    mergeWindow: 1000
  },

  // Search operations
  'search-change': {
    opensGroup: 'organize',
    name: () => 'Search',
    mergeWindow: 2000,
    mergeCondition: () => true // Always merge search operations
  },

  // Column reordering
  'reorder-columns': {
    opensGroup: 'organize',
    name: () => 'Reorder columns',
    mergeWindow: 1000
  }
};
